import { Select, SettingsLink } from '@/ui';
import styles from './styles.module.css';

type Props = {
  className: 'headerSelect' | 'bodySelect';
  href?: string;
  options: any[];
};

export function SettingsSelect({ className, options, href }: Props) {
  const renderOption = (option: any, onClick: (text: string) => void) => {
    return (
      <li key={option.id} onClick={() => onClick(option.text)}>
        <SettingsLink
          href={`${href}/${option.id}`}
          text={option.text}
          role={option?.role || null}
        />
      </li>
    );
  };
  return (
    <div className={styles[className]}>
      {/* TODO: Fix ts lint */}
      <Select options={options} renderOption={renderOption} />
    </div>
  );
}
